import { render, staticRenderFns } from "./HeaderSet.vue?vue&type=template&id=2c2c6f6a&scoped=true"
import script from "./HeaderSet.vue?vue&type=script&lang=js"
export * from "./HeaderSet.vue?vue&type=script&lang=js"
import style0 from "./HeaderSet.vue?vue&type=style&index=0&id=2c2c6f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c6f6a",
  null
  
)

export default component.exports